import { serviceRouteConstants } from "@/Constants/routingConstants";

import { post } from ".";
import { getSubscriptionId } from "../utilities/utils";

/**
 * Function to retrieve notification history.
 *
 * @param {Object} data - The data to be sent in the request
 * @return {Promise} The result of the post request
 */
export const _notificationHistory = async (data) => {
  let postData = {
    nextPage: data.currentPage,
    notification_id: data.notification_id || null,
    subscription_id: getSubscriptionId(),
    // subscription_id: 2,
  };
  // const request = {
  //   endPoint: serviceRouteConstants.notificationHistory,
  //   method: "POST",
  //   data: postData,
  // };
  // return await post(request);
};

/**
 * Marks an individual notification as read.
 *
 * @param {string} notificationId - The ID of the notification to mark as read
 * @return {Promise} The result of marking the notification as read
 */
export const _markNotificationAsRead = async (notificationId) => {
  const request = {
    endPoint: serviceRouteConstants.markAsRead,
    data: {
      notificationId,
    },
  };
  return await post(request);
};

/**
 * Marks all notifications as read.
 *
 * @return {Promise} The result of marking all notifications as read.
 */
export const _markAllNotificationAsRead = async () => {
  const request = {
    endPoint: serviceRouteConstants.markAllAsRead,
    data: {},
  };
  return await post(request);
};

export const _deleteNotification = async (notificationId) => {
  const request = {
    endPoint: serviceRouteConstants.deleteNotification,
    data: {
      notificationId,
    },
  };
  return await post(request);
};

export const _deleteAllNotification = async () => {
  const request = {
    endPoint: serviceRouteConstants.deleteAllNotification,
    data: {},
  };
  return await post(request);
};

export const _fetchClientPublishBankHours = async (data) => {
  // const request = {
  //   endPoint: serviceRouteConstants.clientBankPublishHours,
  //   data: data,
  // };
  // // console.log("request", request);
  // return await post(request);
};

export const _updateClientPublishBankHours = async (data) => {
  const postData = {
    setting_value: data.settingValue,
    setting_name: data.settingName,
  };
  const request = {
    endPoint: serviceRouteConstants.clientBankPublishHoursUpdate,
    data: postData,
  };
  return await post(request);
};

export const _setNewDurationForUnfilledBankPublishContracts = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.clientSetNewUnfilledBankPublishContract,
    data: data,
  };
  return await post(request);
};
